export default {
    namespaced: true,    
    state: {
        obj: [],
    },
    mutations: {
        setObj(state, pload) {
            state.obj = pload
        },
    },
    actions: {
        getObj({rootState, commit}){
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "config/"
                console.log(url)
                fetch (url, {method: 'get', headers: rootState.apiheaders})
                .then (response => response.json())
                .then (response => {
                    commit('setObj', response)
                    resolve(response)
                }, error => {
                    reject(error)
                })
            })
        },
        postObj({rootState}, pload){
            console.log(pload)
            return new Promise((resolve, reject) => {
                var url = rootState.config.apiHost + 'config/'
                console.log(url)
                delete pload._id
                fetch(url, {method: 'post', body:JSON.stringify(pload), headers: {'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                .then(response => response.json())
                .then(response => {
                    console.log(response)
                    if (response.result)
                        resolve(response)
                    else
                        reject(response)
                }, error => {
                    reject(error)
                });
            })
        },        

    },
}